import { createSlice } from "@reduxjs/toolkit";
import { confirmAddressAPI, nonprofitStatsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const nonprofitStatsSlice = createSlice({
  name: "nonprofitStats",
  initialState: data,
  reducers: {
    nonprofitStatsSlice(state) {
      state.isLoading = true;
    },
    nonprofitStatsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    nonprofitStatsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    nonprofitStatsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const nonprofitStatsHandler = (org_id:string) => async (dispatch: any) => {
  try {
    dispatch(nonprofitStatsAction.nonprofitStatsSlice());
    const response: any = await nonprofitStatsAPI(org_id);
    dispatch(nonprofitStatsAction.nonprofitStatsSliceSuccess(response));
  } catch (e: any) {
    dispatch(nonprofitStatsAction.nonprofitStatsSliceFailure(e?.response?.data?.message));
    dispatch(nonprofitStatsAction.nonprofitStatsSliceReset());
  }
};
export const confirmAddressHandler = (org_id:string) => async (dispatch: any) => {
  try {
    dispatch(nonprofitStatsAction.nonprofitStatsSlice());
    await confirmAddressAPI(org_id);
    dispatch(nonprofitStatsHandler(org_id));
  } catch (e: any) {
    dispatch(nonprofitStatsAction.nonprofitStatsSliceFailure(e?.response?.data?.message));
  }
};

export default nonprofitStatsSlice.reducer;
export const nonprofitStatsAction = nonprofitStatsSlice.actions;
